<template>
    <div>
        <a-page-header class="page-header icon" @back="() => null" :sub-title="sub_title">
            <svg class="icon" aria-hidden="true" slot="backIcon" @click="$router.replace('/order')">
                <use xlink:href="#icon-icon_order" />
            </svg>
            <template #title>订单管理<a-icon class="separator" type="right" /> </template>

            <template slot="extra">
                <div class="extra-shortcut">
                    <a-icon type="plus-circle" class="pointer" @click="on_add_shortcut" />
                </div>
            </template>
        </a-page-header>

        <div class="framework-container">
            <div
                class="framework-side"
                :class="[visible_sidebar ? 'visible' : '', small_screen ? 'ss' : '', visible_sidebar ? 'tg-on' : 'tg-off']"
            >
                <div class="module-title">
                    订单管理
                </div>

                <a-menu class="menu" mode="inline" :selected-keys="sidebar_order" :inlineIndent="16">
<!--                    <a-menu-item
                        key="prepare"
                        @click="on_jump('/prepare')"
                        v-if="permissible.indexOf('order_trademark.prepare_create') > -1"
                        >发起订单</a-menu-item
                    >

                    <a-menu-item key="accept" @click="on_jump('/accept')" v-if="permissible.indexOf('order_trademark.generate') > -1"
                        >待处理的订单</a-menu-item
                    >-->

                    <a-menu-item key="order" @click="on_jump('/whole')">订单列表</a-menu-item>

<!--                    <a-menu-item-group title="财务">
                        <a-menu-item key="recharge" @click="on_jump('/recharge')">客户充值列表</a-menu-item>
                        <a-menu-item key="notary" @click="on_jump('/notary')">商标转让公正</a-menu-item>
                    </a-menu-item-group>-->

<!--                    <a-menu-item-group title="申请">

                        <a-menu-item key="loan" @click="on_jump('/apply/loan')"
                            >卖家放款申请
                            <div style="float: right;">
                                <a-badge :count="data_stat.order_loan" :overflowCount="999" class="sidebar-badge" /></div
                        ></a-menu-item>

                        <a-menu-item key="deduct" @click="on_jump('/apply/deduct')"
                            >买家扣款申请
                            <div style="float: right;"></div
                        ></a-menu-item>

                        <a-menu-item key="approval_recharge" @click="on_jump('/apply/recharge')"
                            >客户充值申请
                            <div style="float: right;">
                                <a-badge :count="data_stat.recharge" :overflowCount="999" class="sidebar-badge" /></div
                        ></a-menu-item>

                        <a-menu-item key="refund" @click="on_jump('/apply/refund')"
                            >客户退款申请
                            <div style="float: right;">
                                <a-badge :count="data_stat.balance_refund" :overflowCount="999" class="sidebar-badge" /></div
                        ></a-menu-item>-->

                        <!-- <a-menu-divider></a-menu-divider>
                        <a-menu-item
                            v-if="permissible.indexOf('apply.audit') > -1"
                            key="approval_audit"
                            @click="on_jump('/apply/audit')"
                            >待我审核
                            <div style="float: right;">
                                <a-badge :count="data_stat.audit" :overflowCount="999" class="sidebar-badge" /></div
                        ></a-menu-item> -->
                    </a-menu-item-group>
                </a-menu>
            </div>

            <div class="framework-body" :class="[visible_sidebar ? 'tg-on' : 'tg-off', small_screen ? 'ss' : '']">
                <router-view />
            </div>
        </div>

        <!-- 分配销售 -->
        <modal_distribute />
    </div>
</template>
<script>
    import modal_distribute from "./components/modal_distribute";

    import commonjs from "./mixins/common";
    export default {
        mixins: [commonjs],
        components: { modal_distribute },
        data() {
            return {
                sub_title: "全部订单",
            };
        },
        created() {
            this.load_stat();

            this.$store.commit("change_state", {
                name: "sidebar_key",
                value: "order_trademark",
            });
        },
        computed: {
            data_stat() {
                return this.$store.state.stat_order;
            },
            sidebar_order() {
                return [this.$store.state.sidebar_order];
            },
        },
        methods: {
            on_jump(v) {
                return this.$router.push(`/order${v}`);
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-container {
        .framework-side {
            .toolbar {
                .item {
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;
                    cursor: pointer;
                    .text {
                        font-size: 12px;
                    }
                }
            }
        }
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
        }
    }
</style>
